import type {
  ButtonHTMLAttributes,
  DetailedHTMLProps,
  FC,
  PropsWithChildren,
} from "react";
import classNames from "classnames";
import styles from "./LargeToggleButton.module.scss";

type LargeToggleButtonProps = { isActive?: boolean } & DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

export const LargeToggleButton: FC<
  PropsWithChildren<LargeToggleButtonProps>
> = (props) => {
  const { className, isActive = false, ...restProps } = props;

  return (
    <button
      aria-pressed={isActive}
      className={classNames(
        styles.button,
        { [String(styles.buttonActive)]: isActive },
        className,
      )}
      {...restProps}
    />
  );
};
